(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  // Mobile navigation
  const menuToggle = $('[data-menu-toggle]');
  const mobileNav = $('[data-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const open = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!open));
      mobileNav.hidden = open;
    });
    $$('a', mobileNav).forEach((link) => link.addEventListener('click', () => {
      menuToggle.setAttribute('aria-expanded', 'false');
      mobileNav.hidden = true;
    }));
  }

  // MailerLite forms (preserves the existing HALOPRISM workflow).
  $$('[data-mailerlite-form]').forEach((form) => {
    const status = $('[data-form-status]', form);
    const action = (form.dataset.action || '').trim();
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const email = $('input[type="email"]', form);
      const button = $('button[type="submit"]', form);
      if (!email || !email.validity.valid) {
        if (status) { status.textContent = 'Enter a valid email address.'; status.className = 'hp-form-status is-error'; }
        email?.focus();
        return;
      }
      if (!action) {
        if (status) { status.textContent = 'Email signup is being connected. Please try again shortly.'; status.className = 'hp-form-status is-error'; }
        return;
      }
      const original = button ? button.textContent : '';
      if (button) { button.disabled = true; button.textContent = 'Joining…'; }
      if (status) { status.textContent = ''; status.className = 'hp-form-status'; }
      try {
        await fetch(action, { method: 'POST', mode: 'no-cors', body: new FormData(form) });
        form.reset();
        const live = form.dataset.offerMode === 'live';
        const success = live ? form.dataset.successLive : (form.dataset.successReserve || form.dataset.success);
        if (status) { status.textContent = success || 'You’re on the list.'; status.className = 'hp-form-status is-success'; }
        if (live) {
          const code = $('[data-discount-code]', form);
          if (code) code.hidden = false;
        }
        if (button) button.textContent = 'Joined';
      } catch (error) {
        if (status) { status.textContent = 'We couldn’t add you just now. Please try again.'; status.className = 'hp-form-status is-error'; }
        if (button) { button.disabled = false; button.textContent = original; }
      }
    });
  });

  // Copy launch code.
  $$('[data-copy-code]').forEach((button) => {
    button.addEventListener('click', async () => {
      const code = button.dataset.copyCode || '';
      try {
        await navigator.clipboard.writeText(code);
        const original = button.textContent;
        button.textContent = 'Copied';
        setTimeout(() => { button.textContent = original; }, 1400);
      } catch (_) {}
    });
  });

  // Product gallery.
  $$('[data-product-gallery]').forEach((gallery) => {
    $$('[data-gallery-thumb]', gallery).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const id = thumb.dataset.galleryThumb;
        $$('.hp-product-media', gallery).forEach((media) => media.classList.add('hp-product-media--secondary'));
        const target = $(`[data-media-id="${id}"]`, gallery);
        if (target) target.classList.remove('hp-product-media--secondary');
        $$('.hp-product-thumb', gallery).forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });


  // Keep variant price and availability in sync on multi-variant products.
  $$('.hp-product-main').forEach((root) => {
    const select = $('[data-variant-select]', root);
    const json = $('[data-product-variants]', root);
    const price = $('[data-product-price]', root);
    const submit = $('.hp-product-form button[type="submit"]', root);
    if (!select || !json) return;
    let variants = [];
    try { variants = JSON.parse(json.textContent); } catch (_) { return; }
    select.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === String(select.value));
      if (!variant) return;
      if (price) price.innerHTML = `<span class="hp-price">${money(variant.price)}</span>${variant.compare_at_price && variant.compare_at_price > variant.price ? ` <s class="hp-price__compare">${money(variant.compare_at_price)}</s>` : ''}`;
      if (submit) { submit.disabled = !variant.available; submit.textContent = variant.available ? 'Add to cart' : 'Sold out'; }
      if (history.replaceState) {
        const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
      }
    });
  });

  // Cart drawer.
  const drawer = $('[data-cart-drawer]');
  const drawerItems = drawer ? $('[data-cart-items]', drawer) : null;
  const drawerFooter = drawer ? $('[data-cart-footer]', drawer) : null;
  const subtotal = drawer ? $('[data-cart-subtotal]', drawer) : null;
  const cartCountNodes = $$('[data-cart-count]');

  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
    } catch (_) { return `$${(cents / 100).toFixed(2)}`; }
  };

  const openCart = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  };
  const closeCart = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  };
  $$('[data-cart-open]').forEach((button) => button.addEventListener('click', openCart));
  $$('[data-cart-close]').forEach((button) => button.addEventListener('click', closeCart));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeCart(); });

  const renderCart = (cart) => {
    cartCountNodes.forEach((node) => {
      node.textContent = cart.item_count;
      node.hidden = cart.item_count === 0;
    });
    if (!drawerItems) return;
    if (!cart.item_count) {
      drawerItems.innerHTML = '<p class="hp-cart-empty">Your cart is empty.</p>';
      if (drawerFooter) drawerFooter.hidden = true;
      return;
    }
    drawerItems.innerHTML = cart.items.map((item) => `
      <div class="hp-cart-line">
        ${item.image ? `<img class="hp-cart-line__image" src="${item.image}" alt="">` : ''}
        <div class="hp-cart-line__copy">
          <a href="${item.url}">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<small>${item.variant_title}</small>` : ''}
          <small>Qty ${item.quantity}</small>
          <strong>${money(item.final_line_price)}</strong>
        </div>
      </div>`).join('');
    if (subtotal) subtotal.textContent = money(cart.total_price);
    if (drawerFooter) drawerFooter.hidden = false;
  };

  const refreshCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };

  // AJAX add to cart. Native form submission remains the fallback if JS fails.
  $$('.hp-product-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = $('button[type="submit"]', form);
      const status = $('[data-product-form-status]', form);
      const original = submit ? submit.textContent : '';
      if (submit) { submit.disabled = true; submit.textContent = 'Adding…'; }
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('Unable to add item');
        await response.json();
        await refreshCart();
        if (status) { status.textContent = 'Added to cart.'; status.className = 'hp-form-status is-success'; }
        if (submit) { submit.disabled = false; submit.textContent = original; }
        openCart();
      } catch (error) {
        if (status) { status.textContent = 'Could not add this item. Please try again.'; status.className = 'hp-form-status is-error'; }
        if (submit) { submit.disabled = false; submit.textContent = original; }
      }
    });
  });

  // Related products recommended by Shopify.
  $$('product-recommendations[data-url]').forEach(async (element) => {
    try {
      const response = await fetch(element.dataset.url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const replacement = html.querySelector('product-recommendations');
      if (replacement && replacement.innerHTML.trim()) element.innerHTML = replacement.innerHTML;
    } catch (_) {}
  });
})();
